import React, { useState, useContext } from 'react';
import { Segment, Form, Button } from 'semantic-ui-react';
import { RequestReviewNoteFormValues } from '../../../../../App/models/RequestReviewNote'
import { observer } from 'mobx-react-lite';
import { Form as FinalForm, Field } from 'react-final-form';
import TextAreaInput from '../../../../../App/common/form/TextAreaInput';
import SelectInput from '../../../../../App/common/form/SelectInput';
import { noteTypes } from '../../../../../App/enumerable/NoteTypes';

import {
  combineValidators,
  isRequired,
  composeValidators,
  hasLengthLessThan
} from 'revalidate';

import { RootStoreContext } from '../../../../../App/stores/RootStore'

const validate = combineValidators({
  requestReviewId: isRequired('requestReviewId'),
  noteType: isRequired('noteType'),
  note: composeValidators(
    isRequired('note'),
    hasLengthLessThan(300)({ message: 'Notes have a 300 char limit' })
  )(),
});

interface NoteParams {
  requestReviewId: string;

  validNoteTypes?: {
    key: string;
    text: string;
    value: string;
  }[] | undefined;
}


const RequestReviewNoteCompleteForm: React.FC<NoteParams> = (match) => {
  const rootStore = useContext(RootStoreContext);

  const { createRequestReviewNote, submitting, loadRequestReviewNotes } = rootStore.requestReviewNoteStore;
  const { setNoteResult } = rootStore.requestReviewStore;
  const { closeModal } = rootStore.modalStore;
  const [requestNote] = useState(new RequestReviewNoteFormValues(match.requestReviewId));
  const [loading] = useState(false);

  const handleFinalFormSubmit = (values: any) => {
    const { ...requestReviewNote } = values;

    if (!requestReviewNote.id) {
      let newRequestReviewNote = {
        ...requestReviewNote
      };
      createRequestReviewNote(newRequestReviewNote)
          .then(r => loadRequestReviewNotes(match.requestReviewId));
      setNoteResult();
    }
  };

  return (
    <Segment clearing>
      <FinalForm
        validate={validate}
        initialValues={requestNote}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit, invalid, pristine }) => (
          <Form onSubmit={handleSubmit} loading={loading}>
            <Field
              component={SelectInput}
              options={match.validNoteTypes ? match.validNoteTypes : noteTypes}
              name='noteType'
              placeholder='NoteType'
              value={requestNote.noteType}
            />
            <Field
              rows={4}
              name='note'
              placeholder='Note'
              value={requestNote.note}
              component={TextAreaInput}
            />
            <Button
              loading={submitting}
              disabled={loading || invalid || pristine || submitting}
              floated='right'
              positive
              type='submit'
              content='Submit'
            />
            <Button
              onClick={() => closeModal()}
              disabled={loading}
              floated='left'
              type='button'
              content='Cancel'
            />
          </Form>
        )}
      />
    </Segment>
  );
};

export default observer(RequestReviewNoteCompleteForm);
